module.exports = __webpack_public_path__ + "static/tooltipNo-ccb3719e8a5b6f9cf40757431f8b4c11.png";